import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-6 relative overflow-hidden" data-id="element-118">
      {/* Decorative background element */}
      <div className="absolute inset-0 bg-cream-50 opacity-50 pointer-events-none" data-id="element-119" />
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-gold-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-120" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-olive-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-121" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-122">
        <FadeIn data-id="element-123">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-gold-500/20 text-center" data-id="element-124">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-100 text-gold-600 mb-6" data-id="element-125">
              <ShieldCheck className="w-8 h-8" data-id="element-126" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brown-900" data-id="element-127">
              El Protocolo del Mapa de Unción
            </h2>

            <p className="text-lg md:text-xl text-brown-800 leading-relaxed mb-6" data-id="element-128">
              No es un rito de fuerza, sino un acto de amor y rendición. A
              través de este método, aprenderás a consagrar cada rincón —desde
              la entrada hasta las habitaciones de tus hijos— usando el aceite
              como símbolo de la presencia del Espíritu Santo.
            </p>

            <p className="text-lg md:text-xl text-brown-800 leading-relaxed font-medium" data-id="element-129">
              Aprenderás a declarar bendición habitación por habitación,
              cerrando legalmente toda puerta al conflicto y abriendo las
              ventanas a la visitación de Dios.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}